module.exports = __webpack_public_path__ + "static/media/Logo Horizontal Principal - Sem fundo.9da5c69f.png";